/** Caché local del catálogo (tienda). Si el API pestañea, se sigue mostrando lo último visto. */
const CACHE_KEY = 'oh_tienda_catalogo_v3';
const MAX_CACHE_ENTRIES = 12;

function cacheSlot(q, cat) {
  return `${String(q || '').trim().toLowerCase()}||${cat || 'Todas'}`;
}

export function readCatalogCache(q, cat) {
  try {
    const all = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    const hit = all[cacheSlot(q, cat)];
    if (hit?.productos?.length) return hit;
    if (q || (cat && cat !== 'Todas')) {
      const base = all[cacheSlot('', 'Todas')];
      if (base?.productos?.length) return { ...base, fromFallback: true };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeCatalogCache(q, cat, productos, total) {
  try {
    const all = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    const key = cacheSlot(q, cat);
    all[key] = {
      productos: (productos || []).slice(0, 240),
      total: total || 0,
      at: Date.now(),
    };
    const keys = Object.keys(all);
    if (keys.length > MAX_CACHE_ENTRIES) {
      keys
        .map((k) => ({ k, at: all[k]?.at || 0 }))
        .sort((a, b) => a.at - b.at)
        .slice(0, keys.length - MAX_CACHE_ENTRIES)
        .forEach(({ k }) => {
          delete all[k];
        });
    }
    localStorage.setItem(CACHE_KEY, JSON.stringify(all));
  } catch {
    /* quota / private mode */
  }
}

/** Limpia caché local tras eliminar producto en Admin. */
export function clearCatalogCache() {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    /* ignore */
  }
}

export function filterCachedProducts(list, q, cat) {
  const qq = String(q || '').trim().toLowerCase();
  const isSub = cat && cat !== 'Todas';
  return (list || []).filter((p) => {
    if (isSub) {
      const sub = String(p.subcategoria || p.categoria || '').toLowerCase();
      if (!sub.includes(String(cat).toLowerCase())) return false;
    }
    if (!qq) return true;
    const hay = `${p.codigo || ''} ${p.nombre || ''} ${p.referencia || ''}`.toLowerCase();
    return hay.includes(qq);
  });
}
